<template>
  <table class="counters">
    <tbody v-if="attributes.value.length">
      <tr>
        <th v-if="true" v-for="(item, key) in attributes.value" :key="key" v-markdown="item.label" :style="computeStyle(item, true)" :class="[item.class]"></th>
      </tr>
      <tr>
        <td v-if="true" v-for="(item, key) in attributes.value" :key="key" :style="computeStyle2(item)" :class="[item.class]">
          <div>{{item.count ? item.count : (+variabledata[item.key]).toLocaleString()}}</div>
          <div class="changed" v-markdown="item.change"></div>
        </td>
      </tr>
    </tbody>
    <tbody v-else class="default">
      <tr>
        <th class="confirmed">Confirmed</th>
        <th class="recovered">Recovered</th>
        <th class="deaths">Deaths</th>
      </tr>
      <tr>
        <td class="confirmed">
          {{(+variabledata.numcasesctr).toLocaleString()}}
          <div class="changed">+4 today</div>
        </td>
        <td class="recovered">
          {{(+variabledata.numrecoveredctr).toLocaleString()}}
          <div class="changed">No new cases</div>
        </td>
        <td class="deaths">
          {{(+variabledata.numdiedctr).toLocaleString()}}
          <div class="changed"></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: ['attributes'],
  computed: {
    ...mapState(['variabledata'])
  },
  methods: {
    computeStyle (item, isHeader = false) {
      var style = {}
      style.width = 99 / this.attributes.value.length + '%'
      style.color = 'rgba(255, 255, 255)'
      if (isHeader && item.rgba_color) {
        var rgbaArr = item.rgba_color.replace('rgb(', 'rgba(').replace(')', '').split(',')
        if (rgbaArr.length > 3) {
          rgbaArr.splice(rgbaArr.length - 1)
        }
        rgbaArr.push(' 1)')
        style.backgroundColor = item.rgba_color
      }
      return style
    },
    computeStyle2 (item, isHeader = false) {
      var style = {}
      style.width = 99 / this.attributes.value.length + '%'
      style.color = item.rgba_color || 'rgba(192, 202, 201)'
      if (isHeader && item.rgba_color) {
        var rgbaArr = item.rgba_color.replace('rgb(', 'rgba(').replace(')', '').split(',')
        if (rgbaArr.length > 3) {
          rgbaArr.splice(rgbaArr.length - 1)
        }
        rgbaArr.push(' 1)')
        style.backgroundColor = rgbaArr.join(',')
      }
      return style
    },

  }
}
</script>

<style lang="scss">
table.counters {
  display: inline-table !important;
  width: 100%;
  border-spacing: 15px 0px;
  border-collapse: unset;
  font-size: 15px;
  font-family: $font-CuratorBold;
  text-align: center;
  th, td {
    text-align: center;
    width: 33%;
    padding: 5px;
    border-radius: 5px;
  }
  .default {
    th, td {
      &.confirmed {
        color: rgba(212, 136, 61);
      }
      &.recovered {
        color: rgba(2, 199, 191);
      }
      &.deaths {
        color: rgba(149, 35, 112);
      }
    }
    th {
      &.confirmed {
        background-color: rgba(212, 136, 61, 0.5);
      }
      &.recovered {
        background-color: rgba(2, 199, 191, 0.5);
      }
      &.deaths {
        background-color: rgba(149, 35, 112, 0.5);
      }
    }
  }
  td {
    font-size: 25px;
    font-family: $font-SelaneTextRegular;
    vertical-align: top;
    .changed {
      font-size: 15px;
    }
  }
}
</style>
